import { useFormContext } from 'react-hook-form';

import { type BlockedRecordExamPasserFormType } from './schema';

export const useBlockedRecordExamPasserForm = useFormContext<BlockedRecordExamPasserFormType>;
